import { RootState } from '../types';

const getMaxBookableDays = (state: RootState) =>
  state.listing.entity?.maxBookableDays;

export { getMaxBookableDays };
